<template>
  <br />
  
  <div class="col-sm-12">
    <!-- Tabla de presentación -->  
    <div class="card">

      <div class="card-header card-header-compact">
        <h3 class="card-header-title">Instrumentos</h3>
        <div class="card-header-toolbar">
          <small v-if="loading">Cargando datos...</small>
          <small v-if="!loading && tableData.length === 0">No hay registros</small>
          <input v-model="searchQuery" class="form-control form-control-sm" placeholder="Buscar..." style="width:auto" />
          <button type="button" class="btn btn-sm btn-primary" @click="onAddNew">Agregar</button>
        </div>
      </div>

      <div class="card-body">
        <div class="table-responsive">
          <div v-if="error" class="alert alert-danger">{{ error }}</div>
            <div v-if="error" class="mb-2"><button type="button" class="btn btn-sm btn-outline-primary" @click="retryCatalog">Reintentar</button></div>

          <table class="table table-hover" v-if="!loading">
            <thead>
              <tr class="border-bottom-primary">
                <th scope="col" v-for="(header, index) in displayColumns" :key="index">{{ header.text }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, rowIndex) in paginatedData" :key="rowIndex">
                <td v-for="(col, colIndex) in displayColumns" :key="colIndex">
                  <template v-if="isBooleanLike(item[col.value])">
                    <input type="checkbox" disabled :checked="toBoolean(item[col.value])" />
                  </template>
                  <template v-else>
                    {{ formatCell(item[col.value], col.value) }}
                  </template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="card-footer">
        <div class="d-flex justify-content-between align-items-center mt-2">
          <div>
            <button class="btn btn-sm btn-secondary me-2" :disabled="currentPage === 1"
              @click="prevPage">Anterior</button>
            <button class="btn btn-sm btn-secondary" :disabled="currentPage >= totalPages"
              @click="nextPage">Siguiente</button>
          </div>
          <div>
            <small>Total de registros: {{ filteredData.length }}</small>
            <small v-if="!loading && filteredData.length > 0"> Mostrando {{ paginatedData.length }} de {{
              filteredData.length
              }}</small>
          </div>
          <div>
            <small>Página {{ currentPage }} de {{ totalPages }}</small>
          </div>
        </div>
      </div>
    </div>
    
  </div>

  <!-- Formulario de edición-->
  <div class="card">

    <div class="card-header">
      <!-- Títulos -->
      <h3>Editar Instrumento</h3>
      <span>Formulario de edición de instrumentos</span>
    </div>

    <div class="card-body">
      <form>
        <!-- Aquí irían los campos del formulario para editar un instrumento -->
        <div class="mb-3">
          <label for="instrumentoNombre" class="form-label">Nombre del Instrumento</label>
          <input type="text" class="form-control" id="instrumentoNombre" placeholder="Ingrese el nombre del instrumento">
        </div>
        <div class="mb-3">
          <label for="instrumentoCodigo" class="form-label">Código del Instrumento</label>
          <input type="text" class="form-control" id="instrumentoCodigo" placeholder="Ingrese el código del instrumento">
        </div>
        <div class="mb-3">
          <label for="pais" class="form-label">País</label>
          <select class="form-select" id="pais">
            <option selected>Seleccione un país</option>
            <option value="1">País 1</option>
            <option value="2">País 2</option>
            <option value="3">País 3</option>
          </select>
        </div>
        <div class="mb-3">
          <label for="estadoActivo" class="form-label">Estado Activo: </label>
          <input type="checkbox" class="form-check-input" id="estadoActivo">
        </div>
        <button type="submit" class="btn btn-primary">Guardar Cambios</button>
      </form>
    </div>
  </div>

</template>

<script>
import { useBootsrapStore } from '@/stores/bootsrap';
import getImage from '@/mixins/getImage';
import api from '@/axios';
import catalogListMixin from '@/mixins/catalogListMixin';

export default {
  name: 'BancosPage',
  mixins: [getImage, catalogListMixin],
  data() {
    return {
      tableColumns: [],
      tableData: [],
      loading: false,
      error: null,
      searchQuery: '',
      pageSize: 10,
      currentPage: 1,
      // optional mapping from API keys to friendly labels
      columnLabels: {
        id: 'Id',
        nombre: 'Nombre',
        nombrelargo: 'Nombre Largo',
        codigo: 'Código',
        // add more mappings según el API
      },
    };
  },

  computed: {
    bootstraplist() {
      const s = useBootsrapStore();
      return s.bootstrap || [];
    },

    filteredData() {
      if (!this.searchQuery) return this.tableData;
      const q = this.searchQuery.toLowerCase();
      return this.tableData.filter(item => {
        return Object.keys(item).some(k => {
          const v = item[k];
          return v != null && String(v).toLowerCase().includes(q);
        });
      });
    },

    totalPages() {
      return Math.max(1, Math.ceil(this.filteredData.length / this.pageSize));
    },

    paginatedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.filteredData.slice(start, start + this.pageSize);
    },

    displayColumns() {
      // Use tableColumns (which contains {text,value}) but ensure text is friendly
      return this.tableColumns.map(c => ({ text: this.friendlyLabel(c.value), value: c.value }));
    },
  },

  created() {
    this.loadData();
  },

  methods: {
    // Los listados llegan paginados: el mixin devuelve todas las filas (catálogos de hasta 500)
    // o la página pedida en modo servidor; `null` si otra carga más reciente la reemplazó.
    async fetchData(page = 1) {
      return this.loadCatalogItems('instrumentos', page);
    },

    getColumns(data) {
      if (!Array.isArray(data) || data.length === 0) return [];
      return Object.keys(data[0]);
    },

    buildTableColumns(data) {
      const columns = this.getColumns(data);
      return columns.map(col => ({ text: this.friendlyLabel(col), value: col }));
    },

    buildTableData(data) {
      return data.map((item, index) => ({ id: index + 1, ...item }));
    },

    async loadData(page = 1) {
      const data = await this.fetchData(page);
      if (data === null) return;
      this.tableColumns = this.buildTableColumns(data);
      this.tableData = this.buildTableData(data);
    },

    friendlyLabel(key) {
      if (this.columnLabels && this.columnLabels[key]) return this.columnLabels[key];
      // fallback: capitalize and replace underscores
      return key.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    },

    isBooleanLike(val) {
      if (typeof val === 'boolean') return true;
      if (typeof val === 'string') {
        const v = val.trim().toLowerCase();
        return v === 'true' || v === 'false';
      }
      return false;
    },

    toBoolean(val) {
      if (typeof val === 'boolean') return val;
      if (typeof val === 'string') return val.trim().toLowerCase() === 'true';
      return Boolean(val);
    },

    // Detect ISO-like date strings
    isIsoDateString(val) {
      if (typeof val !== 'string') return false;
      // simple ISO 8601 and common datetime patterns
      const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z?$/;
      const isoRegexNoT = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
      return isoRegex.test(val) || isoRegexNoT.test(val);
    },

    formatDateTime(val) {
      if (val == null) return '';
      let d;
      if (val instanceof Date) {
        d = val;
      } else if (this.isIsoDateString(String(val))) {
        d = new Date(val);
      } else {
        // try parseable
        const parsed = Date.parse(val);
        if (!isNaN(parsed)) d = new Date(parsed);
        else return val;
      }

      if (isNaN(d)) return val;

      const pad = n => String(n).padStart(2, '0');
      const day = pad(d.getDate());
      const month = pad(d.getMonth() + 1);
      const year = String(d.getFullYear());
      const hours = pad(d.getHours());
      const minutes = pad(d.getMinutes());
      const seconds = pad(d.getSeconds());
      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },

    formatCell(val, key) {
      // don't change format for Id columns or those ending in 'Id' (case-insensitive)
      if (key && /(^id$|id$)/i.test(key)) {
        return val == null ? '' : String(val);
      }

      // if value is object (like nested), stringify minimally
      if (val && typeof val === 'object') return JSON.stringify(val);
      // format if it's a date-like value
      if (this.isIsoDateString(val) || typeof val === 'number' && !Number.isNaN(val)) {
        // numbers could be timestamps; try to format if reasonable
        const maybeDate = new Date(val);
        if (!isNaN(maybeDate)) return this.formatDateTime(maybeDate);
      }
      return this.formatDateTime(val);
    },

    prevPage() {
      if (this.currentPage > 1) this.currentPage -= 1;
    },

    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage += 1;
    },
    async onAddNew() {
      // Simple UX: prompt for a name. In a full app we'd open a proper modal/form.
      const nombre = window.prompt('Nombre del nuevo estado:');
      if (!nombre || !nombre.trim()) return;
      const payload = { nombre: nombre.trim() };
      try {
        this.loading = true;
        await api.post('productos', payload);
        // optionally show created item or success message
        // reload data
        await this.loadData();
      } catch (err) {
        console.error('Error creando estado:', err);
        this.error = 'No se pudo crear el registro.';
      } finally {
        this.loading = false;
      }
    },
  },
};

</script>
